import { Button, Carousel } from "antd";
import LoadingComponent from "common/LoadingComponent";
import { Suspense, useRef, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
// import CategoryWiseDefect from "./CategoryWiseDefect";
// import CategoryWiseHourlyDefect from "./CategoryWiseHourlyDefect";
// import DefectTracker from "./DefectTracker";
import OperatorWiseDefect from "./OperatorWiseDefect";
import OperatorWisePerformance from "./OperatorWisePerformance/OperatorWisePerformance";
import AppProductDetails from "./ProductDetails/AppProductDetails";
// import ProductionSummary from "./ProductionSummary";
// import ProductionTracker from "./ProductionTracker";
// import RecommendationAgainstDefects from "./RecommendationAgainstDefects";
// import ResponsibleForDefects from "./ResponsibleForDefects";
import "./style.css";

// Active carousel slides: index 0, 2, 4 (slides 1, 3, 5)
const ACTIVE_SLIDE_IDS = [10, 2, 4];

const AppDashboard = () => {
  const [currentSlide, setCurrentSlide] = useState(10);
  const indexRef = useRef(-1);
  const { line_id } = useParams();
  const [searchParams] = useSearchParams();
  const date = searchParams.get("date");
  const lineIds = line_id.split(",");
  const navigate = useNavigate();

  const setIndex = (value) => {
    indexRef.current = value;
  };

  if (currentSlide === 10) {
    if (indexRef.current <= lineIds.length - 1) {
      setIndex(indexRef.current + 1);
    }
    if (indexRef.current > lineIds.length - 1) {
      setIndex(0);
    }
  }

  const id = lineIds[indexRef.current];

  return (
    <div
      style={{
        padding: "20px",
        minHeight: "100%",
      }}
    >
      <div style={{ textAlign: "right" }}>
        <Button
          type="primary"
          style={{
            marginBottom: "20px",
          }}
          onClick={() => {
            navigate("/digitalization/app-dashboard");
          }}
        >
          Back
        </Button>
      </div>

      <Carousel
        dotPosition="top"
        dots
        autoplay
        infinite
        arrows
        autoplaySpeed={10000}
        beforeChange={(current, nextSlide) => {
          setCurrentSlide(ACTIVE_SLIDE_IDS[nextSlide]);
        }}
        className="app-dashboard-carousel"
      >
        {/* Slide 1 — index 0 */}
        <div>
          <Suspense fallback={<LoadingComponent />}>
            <AppProductDetails
              line_id={id}
              date={date}
              slideId={10}
              currentSlide={currentSlide}
            />
          </Suspense>
        </div>
        {/* Slide 2 — index 1
        <div>
          <Suspense fallback={<LoadingComponent />}>
            <ProductionSummary
              line_id={id}
              date={date}
              slideId={1}
              currentSlide={currentSlide}
            />
          </Suspense>
        </div>
        */}
        {/* Slide 3 — index 2 */}
        <div>
          <Suspense fallback={<LoadingComponent />}>
            <OperatorWisePerformance
              line_id={id}
              date={date}
              slideId={2}
              currentSlide={currentSlide}
            />
          </Suspense>
        </div>
        {/* Slide 4 — index 3
        <div>
          <Suspense fallback={<LoadingComponent />}>
            <ResponsibleForDefects
              line_id={id}
              date={date}
              slideId={3}
              currentSlide={currentSlide}
            />
          </Suspense>
        </div>
        */}
        {/* Slide 5 — index 4 */}
        <div>
          <Suspense fallback={<LoadingComponent />}>
            <OperatorWiseDefect
              line_id={id}
              date={date}
              slideId={4}
              currentSlide={currentSlide}
            />
          </Suspense>
        </div>
        {/* Slide 6 — index 5
        <div>
          <Suspense fallback={<LoadingComponent />}>
            <ProductionTracker
              line_id={id}
              date={date}
              slideId={5}
              currentSlide={currentSlide}
            />
          </Suspense>
        </div>
        */}
        {/* Slide 7 — index 6
        <div>
          <Suspense fallback={<LoadingComponent />}>
            <DefectTracker
              line_id={id}
              date={date}
              slideId={6}
              currentSlide={currentSlide}
            />
          </Suspense>
        </div>
        */}
        {/* Slide 8 — index 7
        <div>
          <Suspense fallback={<LoadingComponent />}>
            <CategoryWiseDefect
              line_id={id}
              date={date}
              slideId={7}
              currentSlide={currentSlide}
            />
          </Suspense>
        </div>
        */}
        {/* Slide 9 — index 8
        <div>
          <Suspense fallback={<LoadingComponent />}>
            <CategoryWiseHourlyDefect
              line_id={id}
              date={date}
              slideId={8}
              currentSlide={currentSlide}
            />
          </Suspense>
        </div>
        */}
        {/* Slide 10 — index 9
        <div>
          <Suspense fallback={<LoadingComponent />}>
            <RecommendationAgainstDefects
              line_id={id}
              date={date}
              slideId={9}
              currentSlide={currentSlide}
            />
          </Suspense>
        </div>
        */}
      </Carousel>
    </div>
  );
};

export default AppDashboard;
